import * as React from "react"
import { Link } from "gatsby"

const Layout = ({ location, title, children }) => {
  const rootPath = `${__PATH_PREFIX__}/`
  const isRootPath = location.pathname === rootPath
  let header

  if (isRootPath) {
    header = (
      <h1 className="main-heading">
        <Link to="/">{title}</Link>
      </h1>
    )
  } else {
    header = (
      <Link className="header-link-home" to="/">
        {title}
      </Link>
    )
  }

  return (
    <div className="min-h-screen bg-gray-100 px-4 pt-6 dark:bg-gray-900">
      <div className="container mx-auto max-w-4xl lg:p-2" data-is-root-path={isRootPath}>
        <header className="global-header mb-2">{header}</header>
        <main>{children}</main>
        <footer className="mt-12 border-t border-gray-200 py-6 text-center text-sm text-gray-500 dark:border-gray-800 dark:text-gray-400">
          © {new Date().getFullYear()}, Built by
          {` `}
          <a
            href="https://einverne.info"
            target="_blank"
            rel="noopener"
            className="font-medium text-gray-700 underline decoration-gray-300 underline-offset-2 transition-colors hover:text-blue-600 dark:text-gray-300"
          >
            Ein Verne
          </a>
        </footer>
      </div>
    </div>
  )
}

export default Layout
